import React, { useState } from 'react';

import classnames from 'classnames';
import Modal from 'components/cosmos/modal';
import { I18n } from 'components/translate';
import { MembershipEventService } from 'modules/membershipEvent';
import { EVENTS } from 'modules/membershipEvent/constants';
import { OnlineEventService } from 'modules/onlineEvent';
import { useResendAccessContext } from 'modules/onlineEvent/context/resendAccess';
import { UiService } from 'modules/ui';

import { sendCancelEvent, sendConfirmEvent } from './events';

const ModalResendAccess = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { modalIsOpen, setModalIsOpen, setBannerIsOpen } =
    useResendAccessContext();

  const onConfirm = async () => {
    try {
      setIsLoading(true);
      sendConfirmEvent();
      await OnlineEventService.resendAccess();
      MembershipEventService.dismissEvent(EVENTS.ONLINE_EVENT_TOMORROW_NOTIFY);
      setModalIsOpen(false);
      setBannerIsOpen(false);
      UiService.setAlertSuccess('resend_access_success');
    } catch (error) {
      UiService.handleError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onCancel = () => {
    sendCancelEvent();
    setModalIsOpen(false);
  };

  const footer = (
    <div className="_d-flex _justify-content-end _w-full">
      <button className="hot-button hot-button--secondary" onClick={onCancel}>
        <I18n label="online_event.resend_access.modal.cancel_button" />
      </button>
      <button
        className={classnames('hot-button hot-button--primary _ml-3', {
          'hot-button--loading': isLoading
        })}
        onClick={onConfirm}
      >
        <I18n label="online_event.resend_access.modal.confirm_button" />
      </button>
    </div>
  );

  return (
    <Modal
      open={modalIsOpen}
      onClose={() => setModalIsOpen(false)}
      footer={footer}
    >
      <>
        <h6 className="_mb-5 _text-3">
          <I18n label="online_event.resend_access.modal.title" />
        </h6>
        <I18n label="online_event.resend_access.modal.description" />
      </>
    </Modal>
  );
};

export default ModalResendAccess;
